export default __webpack_public_path__ + "static/media/creditCard.cfd1ece0.svg";